export const REPORT_TO_SLACK_MUTATION = gql`
  mutation ReportToSlackMutation(
    $channel: String!
    $title: String!
    $message: String
    $fileName: String
    $image: String
    $data: [JSON!]
    $styles: [ExcelStylingOptions!]
    $headers: [JSON!]
    $sendSeparately: Boolean
  ) {
    reportToSlack(
      channel: $channel
      title: $title
      message: $message
      fileName: $fileName
      image: $image
      data: $data
      styles: $styles
      headers: $headers
      sendSeparately: $sendSeparately
    )
  }
`;

export const REPORT_TO_EXCEL_FILE_MUTATION = gql`
  mutation ReportToExcelFileMutation(
    $data: [JSON!]!
    $headers: [JSON!]!
    $title: String!
    $styles: [ExcelStylingOptions!]
  ) {
    reportToExcelFile(
      data: $data
      headers: $headers
      title: $title
      styles: $styles
    )
  }
`;
